import SalesforceSettings from '@/modules/integrations/types/salesforce/SalesforceSettings'
import SalesforceOverview from '@/modules/integrations/types/salesforce/SalesforceOverview'
import ConnectionStep from '@/modules/integrations/types/salesforce/ConnectionStep'
import MultipleMappingStep from '@/modules/integrations/types/salesforce/MultipleMappingStep'
import EventsStep from '@/modules/integrations/types/salesforce/EventsStep'

export default Object.freeze({
  type: 'salesforce',
  title: 'Integrations_Salesforce',
  model: {},
  category: 'Integrations_Salesforce_Category',
  description: 'Integrations_Salesforce_Description',
  image: require('@/img/integrations/salesforce.png'),
  requiresAdmin: false,
  stepped: true,
  components: {
    settings: SalesforceSettings,
    overview: SalesforceOverview
  },
  actions: [
    {
      icon: 'el-icon-plus',
      label: 'Integrations_Salesforce_AddDataExtension',
      action: 'event-bus-emit',
      eventName: 'openDataExtensionsDialog',
      invisibleForRoutes: ['IntegrationOverview']
    }
  ],
  urls: {
    guide: 'https://docs.xtremepush.com/docs/salesforce-marketing-cloud'
  },
  steps: [
    {
      name: 'connection',
      title: 'Integrations_Salesforce_StepConnection',
      component: ConnectionStep,
      completed: false,
      rules: {
        name: {
          required: true,
          message: 'RestForm_FieldIsRequired'
        },
        params: {
          authBaseUrl: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          restBaseUrl: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          soapBaseUrl: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          clientId: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          clientSecret: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          clientMid: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          activityKey: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          },
          jwt_token: {
            required: true,
            message: 'RestForm_FieldIsRequired'
          }
        },
        eventMappings: {
          type: 'array',
          required: true,
          message: 'RestForm_SchemaIsRequired',
          min: 1
        }
      }
    },
    {
      name: 'multiple_data_mapping',
      title: 'Automations_Tab_DataMapping',
      component: MultipleMappingStep,
      completed: false,
      rules: {
        params: {
          required: true,
          type: Array,
          validator: (rule, value, callback) => {
            if (
              !value.hasOwnProperty('enabledDataExtensions') ||
              value.enabledDataExtensions.length === 0
            ) {
              window.vue.$message({
                message: window.vue.$t('Automations_Tab_DeRequired_Error'),
                type: 'error'
              })
              callback(new Error())
            }
            if (
              window.vue.$store.state.app.features.customerIdEnabled &&
              value.contact_id === 'customer_id'
            ) {
              let requiredSelections = 0
              value.enabledDataExtensions.forEach(de => {
                value.mapping.forEach(map => {
                  if (
                    map.dataExtensionId === de.dataExtensionId &&
                    map.hasOwnProperty('attribute') &&
                    map.attribute === 'user_id'
                  ) {
                    requiredSelections++
                    return false
                  }
                })
              })
              if (requiredSelections < value.enabledDataExtensions.length) {
                window.vue.$message({
                  message: window.vue.$t(
                    'Automations_Tab_DeUserID_Required_Error'
                  ),
                  type: 'error'
                })
                callback(new Error())
              }
            }
            callback()
          }
        }
      },
      params: {
        mapping: [],
        enabledDataExtensions: []
      }
    },
    {
      name: 'events',
      title: 'Integrations_Salesforce_StepEvents',
      component: EventsStep,
      completed: false,
      rules: {},
      params: {
        mapping: [],
        eventMappings: []
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/salesforce/index.js